export const MEDIA_PATH = 'media';
export const ASURANSI_PATH = 'new-asuransi';
export const PROMO_PATH = 'new-promo';
export const BUTTON_TEXT = {
  default: 'Tampilkan Pilihan Polis',
  sidebar: 'Cek Premi, Hanya 5 menit!',
};

export const LEADFORM_SOURCE = 'media';
export const QUERY_LIMIT = 250;
export const areaCodes = [
  {
    label: 'BL - Nanggroe Aceh Darussalam',
    value: 'W1 1',
  },
  {
    label: 'BB - Sumatera Utara',
    value: 'W1 2',
  },
  {
    label: 'BK - Sumatera Utara',
    value: 'W1 3',
  },
  {
    label: 'BA - Sumatera Barat',
    value: 'W1 4',
  },
  {
    label: 'BM - Riau',
    value: 'W1 5',
  },
  {
    label: 'BP - Kepulauan Riau',
    value: 'W1 6',
  },
  {
    label: 'BG - Sumatera Selatan',
    value: 'W1 7',
  },
  {
    label: 'BN - Bangka-Belitung',
    value: 'W1 8',
  },
  {
    label: 'BE - Lampung',
    value: 'W1 9',
  },
  {
    label: 'BD - Bengkulu',
    value: 'W1 10',
  },
  {
    label: 'BH - Jambi',
    value: 'W1 11',
  },
  {
    label: 'A - Banten',
    value: 'W2 12',
  },
  {
    label: 'B - DKI Jakarta',
    value: 'W2 13',
  },
  {
    label: 'D - Jawa Barat',
    value: 'W2 14',
  },
  {
    label: 'F - Jawa Barat',
    value: 'W2 15',
  },
  {
    label: 'T - Jawa Barat',
    value: 'W2 16',
  },
  {
    label: 'E - Jawa Barat',
    value: 'W2 17',
  },
  {
    label: 'Z - Jawa Barat',
    value: 'W2 18',
  },
  {
    label: 'H - Jawa Tengah',
    value: 'W3 19',
  },
  {
    label: 'G - Jawa Tengah',
    value: 'W3 20',
  },
  {
    label: 'K - Jawa Tengah',
    value: 'W3 21',
  },
  {
    label: 'R - Jawa Tengah',
    value: 'W3 22',
  },
  {
    label: 'AA - Jawa Tengah',
    value: 'W3 23',
  },
  {
    label: 'AD - Jawa Tengah',
    value: 'W3 24',
  },
  {
    label: 'AB - D.I. Yogyakarta (DIY)',
    value: 'W3 25',
  },
  {
    label: 'L - Jawa Timur',
    value: 'W3 26',
  },
  {
    label: 'W - Jawa Timur',
    value: 'W3 27',
  },
  {
    label: 'N - Jawa Timur',
    value: 'W3 28',
  },
  {
    label: 'P - Jawa Timur',
    value: 'W3 29',
  },
  {
    label: 'AG - Jawa Timur',
    value: 'W3 30',
  },
  {
    label: 'AE - Jawa Timur',
    value: 'W3 31',
  },
  {
    label: 'S - Jawa Timur',
    value: 'W3 32',
  },
  {
    label: 'M - Jawa Timur',
    value: 'W3 33',
  },
  {
    label: 'DK - Bali',
    value: 'W3 34',
  },
  {
    label: 'DR - Nusa Tenggara Barat (NTB)',
    value: 'W3 35',
  },
  {
    label: 'EA - Nusa Tenggara Barat (NTB)',
    value: 'W3 36',
  },
  {
    label: 'DH - Nusa Tenggara Timur (NTT)',
    value: 'W3 37',
  },
  {
    label: 'EB - Nusa Tenggara Timur (NTT)',
    value: 'W3 38',
  },
  {
    label: 'ED - Nusa Tenggara Timur (NTT)',
    value: 'W3 39',
  },
  {
    label: 'KB - Kalimantan Barat',
    value: 'W3 40',
  },
  {
    label: 'DA - Kalimantan Selatan',
    value: 'W3 41',
  },
  {
    label: 'KH - Kalimantan Tengah',
    value: 'W3 42',
  },
  {
    label: 'KT - Kalimantan Timur',
    value: 'W3 43',
  },
  {
    label: 'KU - Kalimantan Utara',
    value: 'W3 44',
  },
  {
    label: 'DB - Sulawesi Utara',
    value: 'W3 45',
  },
  {
    label: 'DL - Sulawesi Utara',
    value: 'W3 46',
  },
  {
    label: 'DM - Gorontalo',
    value: 'W3 47',
  },
  {
    label: 'DN - Sulawesi Tengah',
    value: 'W3 48',
  },
  {
    label: 'DD - Sulawesi Selatan',
    value: 'W3 49',
  },
  {
    label: 'DC - Sulawesi Barat',
    value: 'W3 50',
  },
  {
    label: 'DT - Sulawesi Tenggara',
    value: 'W3 51',
  },
  {
    label: 'DE - Maluku',
    value: 'W3 52',
  },
  {
    label: 'DG - Maluku Utara',
    value: 'W3 53',
  },
  {
    label: 'DS - Papua',
    value: 'W3 54',
  },
  {
    label: 'PA - Papua',
    value: 'W3 55',
  },
  {
    label: 'PB - Papua Barat',
    value: 'W3 56',
  },
];

export const CATEGORY_ID = {
  ASURANSI: 491,
};

export const POST_V2_CATEGORY = [
  'tabungan',
  'layanan-bank',
  'perusahaan-perbankan',
  'tabungan-bisnis-giro',
  'tabungan-deposito',
  'tabungan-haji-umroh',
  'tabungan-syariah',
];

export const TABUNGAN_CATEGORY = [
  'tabungan',
  'layanan-bank',
  'perusahaan-perbankan',
  'tabungan-bisnis-giro',
  'tabungan-deposito',
  'tabungan-haji-umroh',
  'tabungan-syariah',
];

export const CLAIM_TAG_ARTICLES = [];
export const CARTAX_TAG_ARTICLES = [];

export const POST_V2_TAG = [...CLAIM_TAG_ARTICLES, ...CARTAX_TAG_ARTICLES];

export const CATEGORY_SLUG = {
  BENGKEL: 'bengkel',
};

export const FAQ_SHORTCODE = {
  title: 'FAQ',
  content: 'Lihat pertanyaan-pertanyaan yang sering ditanyakan seputar BRI Mobile',
};
export const FOOTER_NAV_ACCOUNT = {
  title: 'Buat Akun untuk Konsultasi Asuransi Gratis Sekarang!',
  subTitle: 'Dapatkan juga tips keuangan, investasi, dan informasi promo terbaru setiap minggunya',
};
export const GTM_CLASS = {
  VIEW_MORE_CONTENT: 'gtm_viewmore_content',
  VIEW_MORE_FAQ: 'gtm_viewmore_faqcolumn',
  VIEW_MORE_ARTICLE: 'gtm_viewmore_articles',
  REDIRECTION_IN_ARTICLE_LINK: 'gtm_redirectionclick_inarticlelink',
  REDIRECTION_IN_ARTICLE_CTA_BANNER: 'gtm_redirectionclick_inarticlectabanner',
  REDIRECTION_FOOTER_INSURANCE: 'gtm_redirectionclick_footerinsurance',
  REDIRECTION_FOOTER_INSURANCE_EC: 'gtm_ec__redirection-click',
  REDIRECTION_FOOTER_INSURANCE_EA: 'gtm_ea__footer-insurance',
  REDIRECTION_FOOTER_INSURANCE_EL: 'gtm_el__',
  REDIRECTION_BENGKEL: 'gtm_redirectionclick_bengkel',
  REDIRECTION_CARTAX: 'gtm_redirectionclick_cartax',
  OPEN_LEADFORM_IN_ARTICLE_BANNER: 'gtm_openleadform_inarticlebanner',
  OPEN_LEADFORM_END_BANNER: 'gtm_openleadform_endbanner',
  OPEN_LEADFORM_FOOTER_BANNER: 'gtm_openleadform_footerbanner',
  OPEN_LEADFORM_IN_ARTICLE_EMBEDDED: 'gtm_openleadform_inarticleembedded',
  OPEN_LEADFORM_BLUE_CTA_POPUP: 'gtm_openleadform_bluectapopup',
  OPEN_LEADFORM_IN_ARTICLE_CTA_BANNER: 'gtm_openleadform_inarticlectabanner',
  OPEN_LEADFORM_CLAIM: 'gtm_openleadform_claim',
  NAVIGATION_CLICK_FOOTER_EXPLORE: 'gtm_navigationclick_footerexplore',
  NAVIGATION_CLICK_FOOTER_INSURANCE: 'gtm_navigationclick_footerinsurance',
  NAVIGATION_CLICK_FOOTER_TOOLS: 'gtm_navigationclick_footertools',
  NAVIGATION_CLICK_FOOTER_MYLIFEPAL: 'gtm_navigationclick_footermylifepal',
  NAVIGATION_CLICK_FOOTER_CLAIM: 'gtm_navigationclick_footerclaim',
  NAVIGATION_CLICK_FOOTER_BENGKEL: 'gtm_navigationclick_bengkel',
  WHATSAPP_BUTTON_CLICK: 'gtm_whatsapppopup_buttonclick',
  WHATSAPP_CANCEL_CLICK: 'gtm_whatsapppopup_cancelclick',
};

export const GTM_ACTION = {
  IN_ARTICLE_BANNER: 'in-article-banner',
  IN_ARTICLE_EMBEDDED: 'in-article-embedded',
  SIDEBAR_LEADFORM: 'sidebar_leadform',
  BLUE_CTA_POPUP: 'blue-cta-popup',
  CLAIM: 'claim',
  LEAD_SUBMIT: 'lead-submit',
  FOOTER_BANNER: 'footer-banner',
  END_BANNER: 'end-banner',
  CALCULATOR: 'calc-cta',
  WHATSAPP_POPUP: 'whatsapp-popup',
};

export const GTM_CLASS_PREFIX = 'gtm_el__';

export const GTM_CATEGORY_PREFIX = 'gtm_ec__';
export const GTM_ACTION_PREFIX = 'gtm_ea__';

export const INSURANCE_BRANDS = [
  'ABDA',
  'ACA',
  'Zurich Asuransi Indonesia',
  'Zurich General Takaful Indonesia',
  'AIA',
  'Al Amin',
  'Allianz',
  'Allianz Life',
  'Amanah Githa',
  'Artarindo',
  'Askrida Syariah',
  'ASPAN General Insurance',
  'Astra',
  'Astra Aviva',
  'Asuransi SLU',
  'Asuransi Wahana Tata',
  'Avrist',
  'AXA Financial',
  'BCA Life',
  'BNI Life',
  'BRI Insurance',
  'BRI Life',
  'CAR',
  'Chubb',
  'Chubb Life',
  'Cigna',
  'Ciputra',
  'Equity Life Indonesia',
  'FWD',
  'GEGI',
  'GELI',
  'Heksa',
  'Jagadiri',
  'Jasindo',
  'Jasindo Syariah',
  'JMA Syariah',
  'KB Insurance',
  'Kresna Life',
  'Lippo',
  'Lippo Life',
  'MAG',
  'MAGI',
  'Manulife',
  'Maximus Graha Persada',
  'Mega Insurance',
  'MSIG',
  'Pacific Cross',
  'Pacific Life',
  'PFI Mega Life',
  'Prudential',
  'Sequis Life',
  'Simas Insurtech',
  'Simas Jiwa',
  'Sinar Mas',
  'SOMPO',
  'Starinvestama',
  'Sun Life',
  'Takaful Keluarga',
  'Takaful Umum',
  'Tokio Marine',
  'Tugu Insurance',
];

export const REDIS_TTL = 60 * 60; // 1 hour
export const REDIS_TTL_ERROR = 60 * 10; // 10 minutes

export const LOGIN_ERROR_MESSAGE = {
  NO_EMPTY_PHONE_NUMBER: 'Nomor Telepon tidak boleh kosong',
  INVALID_PHONE_NUMBER: 'Nomor Telepon tidak valid',
  NO_EMPTY_EMAIL: 'Email harus diisi',
  INVALID_EMAIL: 'Email tidak valid!',
  NO_EMPTY_PASSWORD: 'Password harus diisi',
  MINIMUM_PASSWORD: 'Minimal 6 huruf/angka',
  DISSIMILAR_REPASSWORD: 'Password tidak sama!',
  NO_EMPTY_FULLNAME: 'Nama Lengkap harus diisi',
  NO_EMPTY_GENDER: 'Jenis Kelamin harus diisi',
  UNREGISTERED_PASSWORD_OR_EMAIL: 'Email, No.Telp, atau password tidak terdaftar',
  MINIMUM_KTP_LENGTH: 'Harus 16 Angka',
  REQUIRED_TO_FILL: 'Wajib diisi',
};

export const ACTIVE_LEADS_STATUS = [
  'NEW',
  'INCOMPLETE',
  'CALL_BACK',
  'PAID_INCOMPLETE',
  'PAID_SUSPENDED',
  'UNREACHABLE',
  'ON_PROCESS'
];
